import { graphql } from '../../__generated__';

export const CREATE_BID = graphql(`
  mutation CreateBid($createBidVariables: CreateOrderInput!) {
    bid(createOrderInput: $createBidVariables)
  }
`);
